import { ArrowBack, Business, Delete, Edit } from "@material-ui/icons";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import fetchClient from "../../api/fetchClient";
import Loader from "../../components/Loader";
import message from "../../helper/message";
import AplicacaoPage from "./AplicacaoPage";
import {
  Page,
  ModernHeader,
  HeaderLeft,
  HeaderContent,
  HeaderTitle,
  HeaderSubtitle,
  HeaderActions,
  HeaderActionButton,
  BackButton,
  ContentCard,
  TableWrapper,
  Table,
  TitleRow,
  TableHeaderCell,
  ResultRow,
  TableCell,
  ActionStack,
  IconActionButton,
  DangerButton,
  getTheme,
  spin,
} from "../../components/common";

function AplicacaoIFSGroups() {
    const history = useHistory();
    const theme = getTheme('ifs');
    const [empresas, setEmpresas] = useState([]);
    const [isViewing, setIsViewing] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [newGroupName, setNewGroupName] = useState("");
    const [editandoGrupo, setEditandoGrupo] = useState(null);
    const [deletingId, setDeletingId] = useState(null);

    useEffect(() => {
        getAllAplicacoes();
    }, [isViewing]);

    const getAllAplicacoes = async () => {
        try {
            setIsLoading(true);
            const { data } = await fetchClient.get("/ifs/getAllGroups");
            setEmpresas(data);
        } catch (error) {
            message.error(error.response?.data?.message || "Erro ao buscar grupos");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreateGroup = async () => {
        try {
            if (!newGroupName.trim()) {
                return message.error("Informe o nome do grupo");
            }

            const payload = {
                id: newGroupName.trim()
            };


            await fetchClient.post("/ifs/groups", payload);
            message.sucess("Grupo criado com sucesso!");


            setShowModal(false);
            setEditandoGrupo(null);
            setNewGroupName("");
            getAllAplicacoes();
        } catch (error) {
            message.error(error.response?.data?.message || "Erro ao salvar grupo");
        }
    };

    const onDelete = async (id) => {
        const confirmar = window.confirm("Deseja realmente excluir este grupo?");
        if (!confirmar) return;

        try {
            setDeletingId(id);
            await fetchClient.delete(`/ifs/groups/${id}`);
            message.sucess("Grupo deletado com sucesso");
            getAllAplicacoes();
        } catch (error) {
            message.error(error.response?.data?.message || "Erro ao deletar grupo");
        } finally {
            setDeletingId(null);
        }
    };

    if (isLoading) return <Loader />;

    return (
        <Page>
            {showModal && (
                <ModalOverlay>
                    <ModalContent>
                        <h3>{editandoGrupo ? "Editar Grupo" : "Novo Grupo"}</h3>
                        <StyledInput
                            type="text"
                            placeholder="Nome do grupo"
                            value={newGroupName}
                            disabled={editandoGrupo?.id}
                            onChange={(e) => setNewGroupName(e.target.value)}
                        />

                        <ModalActions>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    setEditandoGrupo(null);
                                    setNewGroupName("");
                                }}
                            >
                                Cancelar
                            </button>
                            <button onClick={handleCreateGroup}>Salvar</button>
                        </ModalActions>
                    </ModalContent>
                </ModalOverlay>
            )}

            <ModernHeader>
                <HeaderLeft>
                    <BackButton
                        color={theme.primary}
                        onClick={() => isViewing ? setIsViewing(false) : history.goBack()}
                    >
                        <ArrowBack />
                    </BackButton>
                    <HeaderContent>
                        <HeaderTitle>
                            <Business style={{ marginRight: "12px", fontSize: "32px" }} />
                            Grupos IFS
                        </HeaderTitle>
                        <HeaderSubtitle>Organize os grupos do IFS</HeaderSubtitle>
                    </HeaderContent>
                </HeaderLeft>
                <HeaderActions>
                    <HeaderActionButton
                        gradient={theme.gradient}
                        onClick={() => {
                            setShowModal(true);
                            setEditandoGrupo(null);
                            setNewGroupName("");
                        }}
                    >
                        <PersonAddIcon style={{ marginRight: '8px' }} />
                        Novo grupo
                    </HeaderActionButton>
                </HeaderActions>
            </ModernHeader>

            <ContentCard>
                {isViewing ? (
                    <AplicacaoPage data={isViewing} isViewing={setIsViewing} />
                ) : (
                    <TableWrapper>
                        <Table>
                            <TitleRow>
                                <TableHeaderCell>Nome</TableHeaderCell>
                                <TableHeaderCell align="center">Ações</TableHeaderCell>
                            </TitleRow>
                            {empresas.map((grupo) => (
                                <ResultRow key={grupo.id}>
                                    <TableCell>{grupo.id}</TableCell>
                                    <TableCell align="center">
                                        <ActionStack>
                                            <IconActionButton
                                                gradient={theme.gradient}
                                                onClick={() => {
                                                    setEditandoGrupo(grupo);
                                                    setNewGroupName(grupo.id);
                                                    setShowModal(true);
                                                }}
                                            >
                                                <Edit />
                                            </IconActionButton>
                                            <DangerButton
                                                onClick={() => onDelete(grupo.id)}
                                                disabled={deletingId === grupo.id}
                                            >
                                                {deletingId === grupo.id ? <LoaderMini /> : <Delete />}
                                            </DangerButton>
                                        </ActionStack>
                                    </TableCell>
                                </ResultRow>
                            ))}
                        </Table>
                    </TableWrapper>
                )}
            </ContentCard>
        </Page>
    );
}

export default AplicacaoIFSGroups;

// ===== COMPONENTES ESPECÍFICOS DESTA PÁGINA =====

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: white;
    padding: 24px 24px 20px 24px;
    border-radius: 8px;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`;

const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    button {
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        border-radius: 4px;
    }

    button:first-child {
        background: #ccc;
    }

    button:last-child {
        background: #ff6b35;
        color: white;
    }
`;

const StyledInput = styled.input`
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 95%;
    outline: none;
    margin-top: 10px;
    margin-bottom: 20px;
    transition: border-color 0.2s;

    &:focus {
        border-color: #ff6b35;
        box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.1);
    }
`;

const LoaderMini = styled.div`
    width: 16px;
    height: 16px;
    border: 2px solid white;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: ${spin} 0.7s linear infinite;
`;
